
export const parseOfx = (ofxContent) => {
  try {
    const transactions = [];
    
    // Remove headers and newlines for easier regex matching
    // Note: This is a simplified parser. Robust OFX parsing is complex.
    // We assume standard SGML-like OFX.
    
    // Find the bank transaction list
    const bankTranListMatch = ofxContent.match(/<BANKTRANLIST>([\s\S]*?)<\/BANKTRANLIST>/i);
    if (!bankTranListMatch) {
      throw new Error("Invalid OFX: No BANKTRANLIST found");
    }
    
    const transactionBlock = bankTranListMatch[1];
    
    // Split by STMTTRN
    const rawTransactions = transactionBlock.split(/<STMTTRN>/i);
    
    rawTransactions.forEach(block => {
      if (!block.trim()) return;
      
      const typeMatch = block.match(/<TRNTYPE>(\w+)/i);
      const dateMatch = block.match(/<DTPOSTED>(\d+)/i);
      const amountMatch = block.match(/<TRNAMT>([-+]?[0-9]*\.?[0-9]+)/i);
      const fitidMatch = block.match(/<FITID>([^<\r\n]+)/i);
      const memoMatch = block.match(/<MEMO>([^<\r\n]+)/i);
      const nameMatch = block.match(/<NAME>([^<\r\n]+)/i);
      
      if (dateMatch && amountMatch) {
        const dateStr = dateMatch[1].substring(0, 8); // YYYYMMDD
        const year = dateStr.substring(0, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        const formattedDate = `${year}-${month}-${day}`;
        
        transactions.push({
          type: typeMatch ? typeMatch[1] : 'OTHER',
          date: formattedDate,
          amount: parseFloat(amountMatch[1]),
          fitid: fitidMatch ? fitidMatch[1].trim() : '',
          memo: memoMatch ? memoMatch[1].trim() : '',
          name: nameMatch ? nameMatch[1].trim() : '',
          raw: block
        });
      }
    });
    
    // Extract Ledger Balance
    // Relaxed regex to capture the value inside BALAMT tag (anywhere in file, looking for the tag content)
    const balanceMatch = ofxContent.match(/<BALAMT>\s*([^<\r\n]+)/i);
    const balanceDateMatch = ofxContent.match(/<DTASOF>\s*([^<\r\n]+)/i);
    
    let balance = null;
    if (balanceMatch) {
        let rawAmount = balanceMatch[1].trim();
        
        // Handle comma as decimal separator if present and no dot (common in some regions/formats)
        if (rawAmount.includes(',') && !rawAmount.includes('.')) {
            rawAmount = rawAmount.replace(',', '.');
        }

        const amount = parseFloat(rawAmount);
        
        if (!isNaN(amount)) {
             let date = null;
             if (balanceDateMatch) {
                 const d = balanceDateMatch[1].trim().substring(0, 8);
                 if (d.length === 8) {
                     date = `${d.substring(0, 4)}-${d.substring(4, 6)}-${d.substring(6, 8)}`;
                 }
             }
             
             balance = { amount, date };
        }
    }
    
    return { transactions, balance };
  } catch (error) {
    console.error("OFX Parse Error:", error);
    throw error;
  }
};
